<template>
    <div class="page">
        <div class="main_body">

                <div class="top_label">
                    <span class="lable_name">

                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :to="{ path: 'work' }">作业管理</el-breadcrumb-item>
                            <el-breadcrumb-item>布置临时作业</el-breadcrumb-item>
                        </el-breadcrumb>

                    </span>

                </div>
                <form class="cyclework_form" :model="form_data">
                    <div class="title">
                        <i class="el-icon-setting"></i>
                        <span class="lable_name">作业名称</span>
                    </div>
                    <div class="top_label_type">
                        <el-input v-model="form_data.title" placeholder="请输入作业名称"></el-input>
                    </div>

                    <div class="title">
                        <i class="el-icon-setting"></i>
                        <span class="lable_name">作业类型</span>
                    </div>
                    <div class="top_label_type">
                        <div>
                            <el-button size="small" type="primary" @click="readDialogShow" class="el-icon-plus"> 阅读在线</el-button>
                            <el-button size="small" type="danger" @click="specialtyDialogShow" class="el-icon-plus"> 应试英语</el-button>
        
                        </div>
                    </div>
                    <div class="articl_list">
                        <el-tag class="selection" v-for="(item,index_) in form_data.read_type" @close="closeRead(index_)" :key="index_" closable>({{ (index_+1) }})、{{item.title}}</el-tag>
             
                    </div>
                    
                    <div class="articl_list">
        
                        <el-tag type="danger" class="selection" v-for="(specialtyitem,index_specialty) in form_data.specialty_type" @close="closeSpecialty(index_specialty)" :key="index_specialty" closable>{{specialtyitem.title}}</el-tag>
                    </div>
    
                    <div class="title">
                        <i class="el-icon-setting"></i>
                        <span class="lable_name">推送设置</span>
                    </div>
                    <div class="top_label_type">
                        <div>
                            <el-button size="small" style="margin-right:10px" type="primary">作业周期</el-button>
                            <el-date-picker
                                v-model="form_data.time"
                                type="datetimerange"
                                align="right"
                                size="small"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="title">
                        <i class="el-icon-setting"></i>
                        <span class="lable_name">推送班级</span>
                    </div>
                    <div class="top_label_type label_typecheckbox_box">
                  
                            <el-checkbox-group v-model="form_data.plan" size="small">
                                <el-checkbox style="margin-left:0" v-for="(item,index) in plan_data" :key="index" :value="item.id" :label="item.id" border>{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                     
                        
                    </div>
                </form>
                
        
                

                <el-button size="small" style="margin-bottom: 20px;" @click="addWork" type="primary">设置完成，确认布置作业</el-button>

                <div class="top_label">
                    <span class="lable_name">推送明细</span>
                </div>
                <div class="top_label_type" style="margin-bottom: 20px;">
                    <div>
                        
                        <el-table
                        :data="work_list"
                        style="width: 100%">
                        <el-table-column
                        type="index"
                        label="序号"
                        width="120">
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            label="标题"
                            
                            >
                        </el-table-column>
                        <el-table-column
                            prop="type_text"
                            label="类型"
                            width="120"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="starttime"
                            width="120"
                            label="开始时间">
                        </el-table-column>
                        <el-table-column
                            prop="endtime"
                            width="120"
                            label="结束时间">
                        </el-table-column>
       
                        <!-- <el-table-column width="120" label="操作">
                            <template slot-scope="scope">
                                <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                               
                            </template>
                        </el-table-column> -->
                        </el-table>
                    </div>
                </div>
                <div class="dialog_box">
                    <read-dialog ref="readdialog" @handsSelect="handsSelect"></read-dialog>
                    <specialty-dialog ref="specialtydialog" @handsSelect="handsSelectSpecialty"></specialty-dialog>
                </div>
                
            </div>
    </div>
</template>
<script>
import Http from "../../apis/work";
import readdialog from "../../../untils/readdialog.vue";
import specialtydialog from "../../../untils/specialtydialog.vue";
export default {
    components:{
        'read-dialog':readdialog,
        'specialty-dialog':specialtydialog
    },
    data(){
        return{
            form_data:{
                read_type:[],
                specialty_type:[],
                plan:[],
                title:'',
                time:null
            },
            
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            plan_data:[],
            work_list:[],
            isVisible: true
        }
        
    },
    created(){
        
        this.form_data = {
                            read_type:[],
                            specialty_type:[],
                            title:'',
                            time:null,
                            plan:[]
                        }
        this.work_list = []
        this.getPlan_()
        
        setTimeout(()=>{
            this.getReadType_()
            this.changeSearch()
        },200)
        
    },

    methods: {

        // 选中文章
        handsSelect(val){
            this.form_data.read_type = val
        },
        handsSelectSpecialty(val){
      
            this.form_data.specialty_type = val
        },
        readDialogShow(){
            this.$refs.readdialog.readDialogShow()
        },
        // 应试
        specialtyDialogShow(){
            this.$refs.specialtydialog.readDialogShow()
        },

        // 搜索阅读文章
        changeSearch(){
            
            this.$refs.readdialog.changeSearch()
        },

    
        // 获取阅读题型、等级、分?
        getReadType_(){
     
            this.$refs.readdialog.getReadDiaoType()
        },
        // 搜索应试文章
        changeSpecialtySearch(){
            
            this.$refs.specialtydialog.changeSearch()
        },
        getSpecialtyType_(){
            this.$refs.specialtydialog.getSpecialtyDiaoType()
        },
        // 获取班级名称
        getPlan_(){
   
            Http.getPlanName().then((res) => {
                this.plan_data = res.data

            });
        },
        // 提交
        addWork(){
            
            var params = JSON.parse(JSON.stringify(this.form_data))
            if (!params.title) {  
                this.$message({
                    message: '请填写本次作业名称',
                    type: 'error'
                });
                return false
            }
  
            if (params.time == null) {  
                this.$message({
                    message: '请选择作业时间周期',
                    type: 'error'
                });
                return false
            }
            const loading = this.$loading({
                lock: true,
                text: '正在布置作业，请稍后...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.3)'
            });
            if(params.read_type){
                this.getAritclData(params.read_type)
                params['read_type'] = this.getAritclData(params.read_type).join(',')
            }
            if(params.specialty_type){
                this.getAritclData(params.specialty_type)
                params['specialty_type'] = this.getAritclData(params.specialty_type).join(',')
            }

            
            params['start_time'] = this.$Common.getTimerange(params.time[0])
            params['end_time'] = this.$Common.getTimerange(params.time[1])
  
            delete params.time;
            Http.createTemporaryWork(params).then((res) => {
                loading.close()
                this.work_list = res.data
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: res.code ? 'success' : 'error'
                });
                // setTimeout(()=>{
                    
                // },1000)
                
            });
        },

        getAritclData(data){
            var result = [];
            for(var index in data){
                result.push(data[index].id)
            }
            return result;
        },

        
        // 清除文章

        closeRead(index){
            var params = this.form_data.read_type
            params.splice(index, 1);
        },
        closeSpecialty(index){
            var params = this.form_data.specialty_type
            params.splice(index, 1);
        }
    }


}
</script>

<style scoped>
.label_typecheckbox_box >>> .el-checkbox-group{
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 15px;
    align-items: flex-start;
}
.cyclework_form{
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-bottom: 25px;
    padding: 20px;
    text-align: left;
}
.articl_list{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 15px;
    margin-bottom: 20px;
}
.cyclework_form .title{
    margin-bottom: 15px;
}

.cyclework_form .title i{
    margin-right: 5px;
}
.page >>> .el-main{
    min-height: 48vw;
}
.top_label{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-bottom: 25px;
}
.lable_name{
    font-size: 16px;
    font-weight: bold;
}
.lable_name >>> .el-breadcrumb{
    font-size: 16px;
}

.top_label_type{
    width: 100%;
    margin-bottom: 20px;
}

</style>
